import styled from 'styled-components';

interface ModalProps {
    readonly hide?: boolean;
    readonly marginBottom?: string;
    readonly active?: boolean;
  }

export const ModalTop = styled.div`
border-radius: 8px 8px 0px 0px;
display:flex;
flex-direction:row;
padding: 20px;
align-items: center;
`

export const ModalDivArrow = styled.div`
  min-width: 20px;
  max-width: 20px;
  font-size: 32px;
  color: #ACB1C0;
  cursor: pointer;
`

export const ModalTopText = styled.div`
  border-top: 1px solid #FCFCFC;
  padding: 20px 40px;
  color: #5D6E81;
  text-align: justify;
  font-size:16px;
  `

export const ModalH1 = styled.h1<ModalProps>`
  color: #43484F;
  font-weight: bold;
  ${props => 'margin-bottom:' +props.marginBottom};
`

export const ModalSpan = styled.span`
  font-weight: bold;
`
export const ModalBottom = styled.div`
  background-color:#FCFCFC;
  border-top: 1px solid #E7E9EC;
  padding: 20px 80px;
  border-radius: 0px 0px 8px 8px;
`

export const ModalBottomLabels = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width:100;
  font-size: 12px !important;
  font-weight: bold !important;
  padding-bottom: 12px;
`

export const ModalDots = styled.div`
  margin-top: 20px;
  height:10px;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: center;
`

export const Dot = styled.div<ModalProps>`
  min-width: 10px;
  min-height: 10px;
  border-radius: 50%;
  margin: 0px 3px;
  background-color: ${props => props.active? '#616366':'#DBDBDC'};
`
